// initial state
const state = {
  loginChange: false
}

// getters
const getters = {}

// actions
const actions = {
  loginChange(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('loginChange');
    //你还可以在这里触发其他的mutations方法
  }
}

// mutations
const mutations = {
  loginChange(state) {
    //这里的state对应着上面这个state
    let apiKey = localStorage.getItem('apiKey');
    const apiKeyDate = Number(window.localStorage.getItem('apiKeyDate'));
    const currentDate = new Date().getTime();
    const utc = currentDate - apiKeyDate;
    const day = utc / (24 * 60 * 60 * 1000);
    if (apiKey) {
      if (day < 1) {
        state.loginChange = true;
      } else {
        state.loginChange = false;
        window.localStorage.removeItem('apiKey');
        window.localStorage.removeItem('apiKeyDate');
      }
    } else {
      state.loginChange = false;
    }
    //你还可以在这里执行其他的操作改变state
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loginchange.js